import { createSelector } from '@reduxjs/toolkit';

import { createReducer } from '../../state/helpers';
import * as constants from './constants';

const LIVE = 1;
const ARCHIVED = 2;

export const STATUS_FILTERS = [
  { id: LIVE, text: 'Live' },
  { id: ARCHIVED, text: 'Archived' },
];

const ALL = 3;
const ADMIN = 4;

export const ROLE_FILTERS = [
  { id: ALL, text: 'All' },
  { id: ADMIN, text: 'Admin' },
];

const initialState = {
  users: {},
  selectedStatusFilter: LIVE,
  page: {},
  selectedRoleFilter: ALL,
};

export const getSelectedStatusFilter = state => state.selectedStatusFilter;
export const getSelectedRoleFilter = state => state.selectedRoleFilter;
export const getRogbotPage = state => state.page;

const getUsersList = state =>
  Object.keys(state.users).map(id => state.users[id]);

export const getLiveUsers = createSelector(getUsersList, users =>
  users.filter(({ active }) => active)
);

export const getFilteredUsers = createSelector(
  getUsersList,
  state => state.selectedStatusFilter,
  state => state.selectedRoleFilter,
  (users, statusFilter, roleFilter) => {
    let filteredUsers = [];
    if (statusFilter === LIVE) {
      filteredUsers = users.filter(({ active }) => active);
    } else if (statusFilter === ARCHIVED) {
      filteredUsers = users.filter(({ active }) => !active);
    }

    if (roleFilter === ADMIN) {
      filteredUsers = filteredUsers.filter(({ role }) => role === 'Admin');
    }

    return filteredUsers;
  }
);

function resetUsers() {
  return initialState;
}

function setUsers(state, { payload }) {
  const { users, meta } = payload;

  const newUsers = users.reduce((map, user) => {
    map[user.id] = user;
    return map;
  }, {});

  return {
    ...state,
    page: meta.page,
    users: {
      ...newUsers,
    },
  };
}

function updateStatusFilter(state, { payload }) {
  return { ...state, selectedStatusFilter: payload };
}

function updateRoleFilter(state, { payload }) {
  return { ...state, selectedRoleFilter: payload };
}

export default createReducer(initialState, {
  [constants.RESET_USERS]: resetUsers,
  [constants.FETCH_USERS_SUCCESS]: setUsers,
  [constants.UPDATE_STATUS_FILTER]: updateStatusFilter,
  [constants.UPDATE_ROLE_FILTER]: updateRoleFilter,
});
